<header id="topnav">
  <app-topbar></app-topbar>
</header>
<app-navbar [showMobileMenu]="showMobileMenu"></app-navbar>
<div class="loading" data-sidebar-icon="twotones">
  <div class="wrapper">
    <router-outlet>
      <button
        *ngIf="showButtonMenu"
        style="
          border: 1px solid #eb6625;
          z-index: 100000;
          display: block;
          position: absolute;
          top: 12px;
          left: 20px;
          position: fixed;
        "
        class="btn btn-dark btn-sm rounded"
        (click)="onToggleMobileMenu();"
      >
        <svg
          *ngIf="!showMobileMenu"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="#eb6625"
          class="bi bi-list"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
          />
        </svg>
        <svg
          *ngIf="showMobileMenu"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-x-lg"
          viewBox="0 0 16 16"
        >
          <path
            d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
          />
        </svg>
      </button>
    </router-outlet>
  </div>
</div>
<app-footer></app-footer>
